import { DOWNLOAD_APP_BANNER_CLOSED } from '../config/types/action.mjs';
import { setDownloadAppBannerStorage } from '../utils/downloadAppBannerStorage.mjs';

const downloadAppBannerStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.type === DOWNLOAD_APP_BANNER_CLOSED) {
    setDownloadAppBannerStorage(store.getState().downloadAppBanner);
  }
  return result;
};

export { downloadAppBannerStorageMiddleware };
